<section class="debt-collection-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form
      class="debt-collection-form__form astral-content-width astral-stack-l"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      novalidate
      >
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['company']"></astral-input>
          <astral-input [control]="form.controls['agencyErrandId']"></astral-input>
          <app-money-box [control]="form.controls['amount']"></app-money-box>
          <astral-date-picker
            [control]="form.controls['createdAt']"
            [model]="dataContext.createdAt"
            [label]="'DEBT_COLLECTION.CREATED_AT'"
            [readonly]="true"
          ></astral-date-picker>
          <astral-input [control]="form.controls['invoiceNumber']"></astral-input>
          <app-money-box [control]="form.controls['invoiceAmount']"></app-money-box>
          <astral-input [control]="form.controls['invoiceRecipient']"></astral-input>
          <app-money-box [control]="form.controls['unpaidInvoiceAmount']"></app-money-box>
          <astral-input [control]="form.controls['externalSystemName']"></astral-input>
        </astral-layout-group>
      </section>
      @if (showTransactions) {
        <section class="astral-section-surface astral-stack-m">
          <h4>
            {{ 'DEBT_COLLECTION.PAYMENTS' | translate }}
            <astral-popover [helpText]="'DEBT_COLLECTION.HELP_TEXT.PAYMENTS'"></astral-popover>
          </h4>
          <app-list-view
            [columnDefinition]="columnTransactionsDefinition"
            [itemsSource]="dataContext.paymentUpdates"
            [preferencesKey]="'invoice.debt-collection.payments'"
          ></app-list-view>
        </section>
      }
      @if (showDebtCollectionLog) {
        <astral-accordion
          [header]="'LOG.HEADER'"
          [startExpanded]="true"
          (stateChanged)="allowSectionInit('debtCollectionLog')"
          [allowWidthExpansion]="true">
          @if (isSectionAllowed('debtCollectionLog')) {
            <app-list-view
              [columnDefinition]="columnDebtCollectionLogDefinition"
              [itemsSource]="dataContext.debtCollectionLogs"
              [preferencesKey]="'invoice.debt-collection.logs'"
            ></app-list-view>
          }
        </astral-accordion>
      }
    </form>
  }
</section>
